import { AUTH_ERROR, SIGN_IN, SIGN_OUT } from "../types/auth";

const initialState = {
  isAuthenticated: false,
  user: null,
  userData: null,
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SIGN_IN:
      return { ...state, isAuthenticated: true, user: payload.user, userData: payload.userData };
    case SIGN_OUT:
      return { ...state, isAuthenticated: false, user: null, userData: null };
    case AUTH_ERROR:
      return { ...state, isAuthenticated: false, authMessage: payload };
    default:
      return state;
  }
};

export default authReducer;
